import React, { memo, useMemo, useCallback } from 'react';
import { createUseStyles, Switch } from 'hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'SwitchFormatter');
const SwitchFormatter = /*#__PURE__*/memo(_ref => {
  let {
    data,
    onChange
  } = _ref;
  const classes = useStyles();
  const isActive = useMemo(() => {
    if ((data === null || data === void 0 ? void 0 : data.nameField) === -2) return true;
    return false;
  }, [data === null || data === void 0 ? void 0 : data.nameField]);
  const handleOnChange = useCallback(() => {
    // We set value create as newOne
    // Backend when receive a -2 knows that has to create that value as a new one
    const newValue = (data === null || data === void 0 ? void 0 : data.nameField) !== -2 ? -2 : -1;
    onChange(data.index, newValue);
  }, [data, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.switchFormatter
  }, /*#__PURE__*/React.createElement(Switch, {
    checked: isActive,
    onChange: handleOnChange
  }));
});
export default SwitchFormatter;